<template lang="pug">
.file-container(v-if="hasItems")
    .items(v-for="(item, index) in folderItems" :key="index")
        .files
            a.aiq-link-preview(@click.prevent="onHandleView(item)")
                font-awesome-icon(:icon="getIconType(item)[0]"
                                :class="getIconType(item)[1]")
                span.text-info {{ getFileName(item) }}
            font-awesome-icon(v-if="isNew && item.progress.uploadPercent === 100" @click="onHandleDelete(item)" icon="fa-trash-can-xmark" class="trash-icon")
        .progress-bar-container
            aiq-progress.progress-bar(:percentage="item.progress.uploadPercent"
                :stroke-width="5"
                :format="() => ''"
                :status="item.progress.uploadStatus")
            .progress-status
            span {{item.progress.progressBarStatus}} | {{item.progress.uploadPercent}}%
</template>

<script>
import get from 'lodash/get';
import GetGlobalSource from '@/libs/mixins/GetGlobalSource';
import {iconClasses, RECORD_KINDS} from './smartDriveUtil';

export default {
  name: 'view-folder',
  mixins: [GetGlobalSource],
  emits: ['onDeleteFolder'],
  props: {
    folderItems: {
      type: Array,
      default: () => [],
    },
    isNew: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasItems() {
      return this.folderItems.length > 0;
    },
  },

  methods: {
    async onHandleView(item) {
      if (this.isNew) {
        return;
      }
      const mime = get(item, 'payload.mime', '');
      let objectType;
      if (mime === RECORD_KINDS.FOLDER) {
        objectType = RECORD_KINDS.FOLDER;
      } else if (mime === RECORD_KINDS.HTML) {
        objectType = RECORD_KINDS.URL;
      } else {
        objectType = RECORD_KINDS.FILE;
      }
      const recordId = get(item, 'id');
      const path = `/settings/smartdrive/${recordId}`;
      this.$router.push({
        path,
        query: { type: objectType },
      });

      await this.getFileUrl(get(item, 'payload'));
    },
    getFileName(item) {
      return get(item, 'payload.name', '');
    },
    link(item) {
      return get(item, 'payload.url', '');
    },
    getIconType(item) {
      const object_type = get(item, 'payload.mime', '');
      return iconClasses(object_type);
    },
    onHandleDelete(item) {
      this.$emit('onDeleteFolder', {
        file: item,
        type: RECORD_KINDS.FOLDER,
      });
    },

  },
};
</script>
<style lang="scss" scoped>
.aiq-link-preview{
    display: flex;
    gap: 10px;
    cursor: pointer;
}

.trash-icon {
   margin-right: 10px;
   color: rgb(218, 55, 55);
   cursor: pointer;
}

.progress-bar {
    padding-top: 10px;
    width: 325px;
}

.files {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;
}

.progress-bar-container {
    margin-top: 5px;
}

.text-info {
    font-size: 16px;
}
.file-container {
    height: 300px;
    overflow-y: auto;
    border: #dcdfe6 1px solid;
    box-shadow: 0 0 0 1px #dcdfe6 inset;
    width: 325px;
    margin-top: 10px;
    padding-top:10px;
    padding-left: 10px;
}

.doc-icon {
    color: #59b4FF;
}

.link-icon {
    color: #59b4FF;
}

.pdf-icon {
    color: #E34850;
}

.csv-icon {
    color: #1D9E74;
}

.ppt-icon {
    color: #E37C2B;
}

.image-icon {
    color: #59b4FF;
}

.text-icon {
    color: #9e9736;
}

.folder-icon {
    color: grey;
}

.unknown-icon {
    color: rgb(44, 36, 36);
}
</style>